//-----------------------------------------------------------------------
// Copyright © 2022 ManpowerGroup. All Rights Reserved.
//-----------------------------------------------------------------------

/* eslint-disable prettier/prettier */
const signOutURI = process.env.REACT_APP_AD_SIGNOUT_URI;
const signOut = () => {
    sessionStorage.clear();
    localStorage.clear();
    window.location.href = signOutURI;
};

export { signOut }
